<template>
  <MDropdown full-height :tag="tag">
    <template #trigger="{ toggle, open, a11yProps }">
      <div
        class="m-sub-nav-item__trigger"
        :class="{ 'm-sub-nav-item__trigger--active': active }"
      >
        <MNavLink
          v-bind="{ ...triggerAttributes, ...a11yProps }"
          @click="toggle"
        >
          <slot />
          <MSpacing left="xxs">
            <span class="m-sub-nav-item__icon">
              <MIcon
                size="lg"
                block
                :icon="open ? 'chevron-up' : 'chevron-down'"
              />
            </span>
          </MSpacing>
        </MNavLink>
      </div>
    </template>
    <template #content="{ hide }">
      <MDropdownContent>
        <MDropdownLink
          v-for="subItem in items"
          :key="subItem.href"
          size="large"
          :href="subItem.href"
          :active="subItem.active"
          :data-qa-locator="subItem.qaLocator"
          :tag="subItem.tag"
          @click="hide"
        >
          <span class="m-sub-nav-item__text">{{ subItem.text }}</span>
        </MDropdownLink>
      </MDropdownContent>
    </template>
  </MDropdown>
</template>

<script lang="ts">
import MDropdown from '../../controls/Dropdown/MDropdown.vue'
import MDropdownContent from '../../controls/Dropdown/MDropdownContent.vue'
import MDropdownLink from '../../controls/Dropdown/MDropdownLink.vue'
import MSpacing from '../../layout/Spacing/MSpacing.vue'
import MIcon from '../../typography/Icon/MIcon.vue'
import MNavLink from '../Nav/MNavLink.vue'

export default {
  name: 'MSubNavItem',
  components: {
    MDropdown,
    MDropdownContent,
    MDropdownLink,
    MIcon,
    MNavLink,
    MSpacing,
  },
  props: {
    /**
     * Sub navigation items to render
     */
    items: {
      type: Array,
      default: () => [],
    },
    /**
     * Whether this contains the current
     * nav item
     */
    active: {
      type: Boolean,
      default: false,
    },
    /**
     * HTML tag to render for the dropdown
     */
    tag: {
      type: String,
      default: 'li',
    },
  },
  data() {
    return {
      showSubNav: false,
    }
  },
  computed: {
    subNavTriggerTag() {
      // Renders an anchor tag server-side for SEO
      return this.showSubNav ? 'button' : (this.items[0] as any).tag || 'a'
    },
    triggerAttributes() {
      const href = this.showSubNav
        ? null
        : (this.items[0] as { href: string }).href
      return { tag: this.subNavTriggerTag, href }
    },
  },
  mounted() {
    // Convert anchor into button upon client-side hydration
    this.showSubNav = true
  },
}
</script>

<style lang="scss" scoped>
.m-sub-nav-item {
  &__trigger {
    position: relative;
    white-space: nowrap;

    &--active {
      &::after {
        background-color: var(--color-primary-regular);
        bottom: 0;
        content: '';
        height: 6px;
        left: 0;
        position: absolute;
        width: 100%;
      }
    }
  }

  &__icon {
    pointer-events: none; // to stop vue-click-outside directive from thinking element is missing, will rely on parent click event instead
  }

  &__text {
    display: block;
    min-width: 184px;
  }
}
</style>
